module.exports = __webpack_public_path__ + "static/media/right-arrow-dark-blue.ab36d718.webp";